import { useEffect } from "react";
import pages from "../data/pages.json";

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

// Keeps the title and meta tags in sync during client-side navigation.
// scripts/prerender.js writes the same tags into the static HTML for crawlers.
const useSeo = ({ path, title, description }) => {
  useEffect(() => {
    const url = pages.site.url + path;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
  }, [path, title, description]);
};

export default useSeo;
